var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29718 3.22458L10.0003 3.91997L10.7035 3.22458L11.3142 2.6206C11.3144 2.62044 11.3146 2.62028 11.3147 2.62012C11.3148 2.62009 11.3148 2.62006 11.3148 2.62003C13.0619 0.895651 15.9117 0.894098 17.6639 2.62107C19.1179 4.08303 19.4874 6.47509 18.2669 9.40748L18.2665 9.40854C17.5434 11.1514 16.2512 12.9902 14.713 14.3834C13.1571 15.7926 11.4813 16.6306 10.0003 16.6306C8.51905 16.6306 6.84228 15.7931 5.28575 14.3844C3.7468 12.9917 2.45394 11.153 1.73098 9.40884L1.73076 9.40832C0.513192 6.47551 0.882709 4.08317 2.33679 2.62108C4.08913 0.893982 6.93918 0.895648 8.68623 2.62038C8.6863 2.62045 8.68637 2.62052 8.68645 2.6206L9.29718 3.22458Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOutline);
export default __webpack_public_path__ + "static/media/heart-outline.96d196bf1041e69b7adbccb487cb076e.svg";
export { ForwardRef as ReactComponent };